import React from 'react';
import OrderOutgoingShipmentDocuments from './OrderOutgoingShipmentDocuments';

export default props => (
  <div>
    <h2 className="h3 mt-5 mb-4">Ship Collateral</h2>
    <p className="mb-4">
      A shipping label has been generated for you. Please ship the collateral
      file associated with this order.
    </p>
    {!!props.order.documents && (
      <OrderOutgoingShipmentDocuments documents={props.order.documents} />
    )}
    <p className="mb-4">
      <a
        href={props.order.outgoingLabelUrl}
        className="btn btn-primary"
        target="_blank"
      >
        Print Shipping Label
      </a>
    </p>
    <p>
      Once you have shipped the package, you can{' '}
      <strong>
        <a href="/" onClick={props.markShipped}>
          set order status to shipped
        </a>
      </strong>.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderOutgoingShipmentSection.js